var angular = require('angular');

require('angular-router-browserify')(angular);
//require('angular-ui-date');
require('angular-sanitize');

// angular.module('app', ['ngRoute', uidate.name,'ngSanitize']);
angular.module('app', ['ngRoute', 'ngSanitize']);